import { getDeliverySolutions as publicGetDeliverySolutions } from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getDeliverySolutions: MaybeContext<
  BuildRESTFunction<typeof publicGetDeliverySolutions> &
    typeof publicGetDeliverySolutions
> = /*#__PURE__*/ createRESTModule(publicGetDeliverySolutions);

export {
  DimensionsUnit,
  SubscriptionFrequency,
  SubdivisionType,
  VatType,
  WeightUnit,
  PickupMethod,
  RuleType,
  WebhookIdentityType,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
export {
  DeliveryRatesGateway,
  MissingDefaultDeliveryProfileEvent,
  GetDeliverySolutionsRequest,
  DeliverableItem,
  CatalogReference,
  PhysicalProperties,
  Dimensions,
  SubscriptionSettings,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  FullAddressContactDetails,
  VatId,
  UserPreference,
  ExternalReference,
  ExtendedFields,
  GetDeliverySolutionsResponse,
  DeliverySolution,
  DeliveryReference,
  DeliveryLogistics,
  PickupDetails,
  DeliveryTimeSlot,
  DeliveryCost,
  MultiCurrencyPrice,
  AdditionalCost,
  DeliveryAllocation,
  Carrier,
  Region,
  ApplicableLineItems,
  DeliveryCarrierError,
  Details,
  DetailsKindOneOf,
  ApplicationError,
  ValidationError,
  FieldViolation,
  SystemError,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetDeliverySolutionsOptions,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
export {
  DimensionsUnitWithLiterals,
  SubscriptionFrequencyWithLiterals,
  SubdivisionTypeWithLiterals,
  VatTypeWithLiterals,
  WeightUnitWithLiterals,
  PickupMethodWithLiterals,
  RuleTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  GetDeliverySolutionsApplicationErrors,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
